module.exports = {
	"da": {
		"conversation": {
			"widget": {
				"title": "Chat med os"
			}
		}
	}
};